import { render, staticRenderFns } from "./CollaboratorList.vue?vue&type=template&id=2afd0c66&"
import script from "./CollaboratorList.vue?vue&type=script&lang=js&"
export * from "./CollaboratorList.vue?vue&type=script&lang=js&"
import style0 from "./CollaboratorList.vue?vue&type=style&index=0&id=2afd0c66&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports